import React, { useEffect, useState } from 'react';
import Tool from '../Tool/Tool';
import { useToolsContext } from '../../context/ToolsContext';
import { useTranslation } from 'react-i18next';

const PanComponent = () => {

  const { toolStates, setToolState } = useToolsContext();
  const { t } = useTranslation();


  function closeAnothersTools() {
    //TODO
  }

  useEffect(() => {
    if (toolStates && toolStates.panComponent && toolStates.panComponent.active) {
      document.body.style.cursor = 'grab'; // Cambiar cursor a mano (grab)
      closeAnothersTools();
    } else {
      document.body.style.cursor = 'default'; // Cambiar cursor a puntero normal
    }

    // Limpiar el estilo del cursor cuando el componente se desmonte o cambie de estado
    return () => {
      document.body.style.cursor = 'default'; // Restaurar el cursor a su valor predeterminado
    };

  }, [toolStates.panComponent]);

  return (

    <Tool
      id="panComponent"
      type="clickable"
      icon='bi bi-arrows-move'
      label={t('Pan')}
    />

  );
};

export default PanComponent;
